import { cn } from "@/lib/utils"
import {
  getLogoUrl,
  LOGO_ICON_CLASS,
  logoMeta,
  type LogoKey,
  type LogoVariant
} from "@/lib/licenseLogos"
import { useState } from "react"
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover"

type LicenseLogoProps = {
  logo: LogoKey
  variant?: LogoVariant
  className?: string
  title?: string
}

export const LicenseLogo = ({
  logo,
  variant = "color",
  className,
  title
}: LicenseLogoProps) => {
  const src = getLogoUrl(logo, variant)
  const label = title ?? logoMeta[logo].title
  const [open, setOpen] = useState(false)
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <span
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          onFocus={() => setOpen(true)}
          onBlur={() => setOpen(false)}
          onTouchStart={() => setOpen(true)}
          className="inline-flex"
        >
          <img
            src={src}
            alt={label}
            className={cn(LOGO_ICON_CLASS, className)}
            loading="lazy"
          />
        </span>
      </PopoverTrigger>
      <PopoverContent side="top" align="center" className="w-auto px-3 py-1 text-xs">
        {label}
      </PopoverContent>
    </Popover>
  )
}
